import React, { memo, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Tour } from '@web/web5';
import { getLiteral } from 'utils/getLiteral';
import { setNewToursObj } from 'utils/tours';

const TOUR_NAME = 'entityTypeSidebar';

const EntityTypeSidebarTour = memo(() => {
    const { tourDisabled } = useSelector((state) => ({
        tourDisabled: state.config.components?.tours?.[TOUR_NAME]?.[TOUR_NAME]?.disabled,
    }));
    const steps = useMemo(() => {
        return [
            {
                selector: '.fm-entity-type-sidebar > div > span',
                title: getLiteral('label_promotion_salesorders_types'),
                description: getLiteral('label_promotion_salesorders_types_body'),
                event: 'tour:end',
            },
        ];
    }, []);

    const onCloseTour = useCallback(() => {
        setNewToursObj({ entity: TOUR_NAME, tourName: TOUR_NAME });
    }, []);

    if (tourDisabled) return null;
    return <Tour steps={steps} delay={1000} onClose={onCloseTour} />;
});

export default EntityTypeSidebarTour;
